import { z } from "zod";

export const updateAccountResponseSchema = z.boolean();

export type UpdateAccountResponseType = z.infer<typeof updateAccountResponseSchema>;
